"use client";
import { usePopper as n } from "react-popper";
const p = (t, { hoverElement: o, targetElement: e }) => {
  const { styles: s, attributes: r } = n(o, e, {
    strategy: "fixed",
    placement: t === "dropdown" ? "bottom-start" : "right-start",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: t === "dropdown" ? [-6, 4] : [-6, 8]
        }
      }
    ]
  });
  return { styles: s, attributes: r };
};
export {
  p as usePopoverStyles
};
